import { mapState } from 'vuex';
import { planTypes } from "@/common/constants";
import { getPlanLogo } from '@/common/plan-logo-map';
import { translateToEn } from '@/plugins/i18n'

export default {
  key: planTypes[planTypes.ZONE_EDU_PLUS],
  data() {
    return {
      title: this.$t('billing.zone_edu_plus.title'),
      planType: planTypes.ZONE_EDU_PLUS,
      logo: getPlanLogo(planTypes.ZONE_EDU_PLUS),
      trackingPlanName: translateToEn('billing.zone_edu_plus.title'),
      description: this.$t('billing.zone_edu_plus.desc'),
    }
  },
  computed: {
    ...mapState({
      planMapFlat: (state) => state.ShoppingCart.planMapFlat,
    }),
  },
}
